import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../providers/rest.service';
import { ToastrService } from 'ngx-toastr';
import { Kullanici } from '../model/kullanici';
import { KullaniciGrup } from '../model/kullanici-grup';
import { Sube } from '../model/sube';
import { KullaniciSubeDuzenleRequest } from '../model/kullanici-sube-duzenle-request';
import { AuthService } from 'src/auth/auth.service';

@Component({
  selector: 'app-kullanici-ekle-duzenle',
  templateUrl: './kullanici-ekle-duzenle.component.html',
  styleUrls: ['./kullanici-ekle-duzenle.component.css']
})
export class KullaniciEkleDuzenleComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  kullanici: Kullanici = null;
  kullanciGruplari: KullaniciGrup[] = null;
  subeler: Sube[] = null;
  selectAllVal = false;
  kullaniciGrupId: number;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private restService: RestService,
    private toastrService: ToastrService,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      this.kullaniciGrupId = this.authService.getUser().kullaniciGrupId;

      if (this.id !== '0') {
        this.getKullanici();
      } else {
        this.kullanici = new Kullanici();
        this.kullanici.kullaniciAdi = '';
        this.kullanici.adSoyad = '';
        this.kullanici.epostaAdresi = '';
        this.kullanici.sifre = '';
        this.kullanici.kullaniciGrupId = null;
        this.kullanici.vkn = '';
        this.getKullaniciGruplar();
        this.getSubeler();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getKullanici() {
    debugger;
    this.restService.kullaniciDetay(this.id).subscribe(res => {
      if (res) {
        this.kullanici = res;
        this.getKullaniciGruplar();
        this.getSubeler();
      }
    });
  }

  save() {
    const subscription = res => {
      const subeRequest = new KullaniciSubeDuzenleRequest();
      this.kullanici.id = res.id;
      subeRequest.kullaniciId = this.kullanici.id;
      subeRequest.subeIdList = this.subeler.filter(x => x.checked).map(x => x.id);

      this.restService.kullaniciSubeDuzenle(subeRequest).subscribe(res2 => {
        this.toastrService.show('Kaydedildi', 'Başarılı');
        if (this.kullaniciGrupId === 1)
          this.router.navigate(['kullanicilar']);
      });
    };
    if (this.id === '0') {
      var kullanici = this.restService.kullaniciEkle(this.kullanici);
      kullanici.subscribe(subscription);
    } else {
      this.restService.kullaniciDuzenle(this.kullanici).subscribe(subscription);
    }
  }

  getKullaniciGruplar() {
    this.restService.kullaniciGruplar().subscribe(res => {
      this.kullanciGruplari = res;
    });
  }

  getSubeler() {
    this.restService.subeler().subscribe(res => {
      if (res) {
        this.subeler = res;
        if (this.kullanici.subeler != null) {
          for (const e of this.subeler) {
            if (this.kullanici.subeler.findIndex(x => x.id === e.id) !== -1) {
              e.checked = true;
            }
          }
          this.selectAllVal = this.subeler.findIndex(x => !x.checked) === -1;
        }
      }
    });
  }

  selectAll() {
    this.subeler.forEach(x => x.checked = this.selectAllVal);
  }

  selectAllUpdate() {
    this.selectAllVal = this.subeler.findIndex(x => !x.checked) === -1;
  }
}
